import { useEffect, useState } from "react";
import { Navbar } from "@/components/wedding/Navbar";
import { Hero } from "@/components/wedding/Hero";
import { Story } from "@/components/wedding/Story";
import { RumiCorner } from "@/components/wedding/RumiCorner";
import { Events } from "@/components/wedding/Events";
import { Travel } from "@/components/wedding/Travel";
import { Gallery } from "@/components/wedding/Gallery";
import { Faq } from "@/components/wedding/Faq";
import { RsvpForm } from "@/components/wedding/RsvpForm";
import { Community } from "@/components/wedding/Community";
import { Guestbook } from "@/components/wedding/Guestbook";
import { Suggestions } from "@/components/wedding/Suggestions";
import { BrandStyle } from "@/components/wedding/BrandStyle";
import { Footer } from "@/components/wedding/Footer";
import { getContent } from "@/lib/api";

const DEFAULT_ORDER = ["events", "rsvp", "story", "rumi", "travel", "gallery", "guestbook", "suggestions", "faq", "community"];

export default function Home() {
  const [content, setContent] = useState(null);
  const isPreview = new URLSearchParams(window.location.search).get("preview") === "1";

  useEffect(() => {
    getContent(isPreview).then(setContent).catch(() => {});
  }, [isPreview]);

  useEffect(() => {
    if (content?.meta_title) document.title = content.meta_title;
  }, [content]);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--ivory)]" data-testid="home-loading">
        <p className="font-serif italic text-2xl text-[var(--gold)]">Loading…</p>
      </div>
    );
  }

  const renderers = {
    story: () => (content.sections?.story !== false ? <Story key="story" story={content.story} /> : null),
    rumi: () => <RumiCorner key="rumi" rumi={content.rumi} />,
    events: () => (content.sections?.events !== false && content.events?.length > 0 ? <Events key="events" events={content.events} /> : null),
    travel: () => (content.sections?.travel !== false ? <Travel key="travel" travel={content.travel} venue={content.venue} /> : null),
    gallery: () => (content.sections?.gallery !== false && content.gallery?.length > 0 ? <Gallery key="gallery" images={content.gallery} /> : null),
    faq: () => <Faq key="faq" faq={content.faq} />,
    community: () => (content.community?.enabled ? <Community key="community" community={content.community} /> : null),
    guestbook: () => (content.guestbook?.enabled ? <Guestbook key="guestbook" guestbook={content.guestbook} /> : null),
    suggestions: () => (content.suggestions?.enabled ? <Suggestions key="suggestions" suggestions={content.suggestions} /> : null),
    rsvp: () => <RsvpForm key="rsvp" content={content} />,
  };

  const stored = content.section_order?.length ? content.section_order : DEFAULT_ORDER;
  const order = [...stored, ...DEFAULT_ORDER.filter((k) => !stored.includes(k))];

  return (
    <div className="bg-[var(--ivory)] overflow-x-hidden" data-testid="home-page">
      <BrandStyle theme={content.theme} />
      {isPreview && (
        <div className="bg-[var(--burgundy)] text-white text-center text-xs sm:text-sm py-2 px-4" data-testid="preview-banner">
          Preview mode — showing your unpublished draft. Guests don't see this yet.
        </div>
      )}
      <Navbar names={`${content.couple?.partner1} & ${content.couple?.partner2}`} sections={content.sections} order={order} guestbookOn={content.guestbook?.enabled} suggestionsOn={content.suggestions?.enabled} />
      <Hero content={content} />
      {order.map((k) => renderers[k]?.())}
      <Footer content={content} />
    </div>
  );
}
